import { Component, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { MenuService } from '@frontend-site/main-header/domain';

@Component({
    selector: 'p-mega-menu-container',
    templateUrl: './megaMenu-container.component.html',
    styleUrls: ['./megaMenu-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MegaMenuContainerComponent {
    megaMenuColumns$ = this.menuService.megaMenuColumns$;

    @Output() close = new EventEmitter();
    constructor(private readonly menuService: MenuService) {}
}
